import styled from 'styled-components';

import { gray1, gray2, gray5 } from './Const';

export const TemplateCardOuterDiv = styled.div`
    margin-bottom: 15px;
    border-radius: 3px;
    background-color: white;
    overflow: auto;
    transition: 0.2s ease-in-out;

    &:hover {
        box-shadow: 0 6px 18px 0 fade(${gray1}, 30%);
    }

    @media (min-width: 768px) {
        margin-bottom: 30px;
    }
`;

export const TextTruncate = styled.div`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const ThumbInfo = styled.div`
    padding: 18px 18px 24px 18px;
    color: ${gray2};
    height: 120px;

    @media (min-width: 992px) {
            height: 104px;
    }
`;

export const TemplateThumb = styled.div`
    background-color: ${gray5};

    @media (min-width: 768px) {
        height: 124px;
    }

    @media (min-width: 992px) {
        height: 165px;
    }

    @media (min-width: 1200px) {
        height: 166px;
    }
`;



// WEBPACK FOOTER //
// ./assets/js/styles/TemplateCard.ts